export const translations = {
  zh: {
    nav: {
      home: '首页',
      menu: '菜单',
      leaderboard: '牛人榜',
      smartMoneyTrades: '实时聪明钱交易',
      positions: '我的持仓',
      myCopyTrading: '我的跟单',
      wallets: '我的钱包',
      invite: '邀请好友',
    },
    common: {
      retry: '重试',
      backHome: '返回首页',
      loading: '加载中...',
      close: '关闭',
      copy: '复制',
      copied: '已复制',
      login: '登录',
      logout: '退出登录',
      confirm: '确认',
      cancel: '取消',
      save: '保存',
      langZh: '中文',
      langEn: 'English',
    },
    membership: {
      free: 'Free',
      lite: 'Lite',
      pro: 'Pro',
      vip: 'VIP',
      currentTier: '当前会员',
      upgrade: '升级会员',
      upgradeTitle: '升级会员',
      subtitle: '解锁跟单与交易员深度数据',
      upgradeKicker: '解锁高级功能',
      upgradeNow: '立即升级',
      viewPlans: '查看会员方案',
      upgradeRequired: '需要升级会员',
      loading: '加载会员方案中...',
      loadFailed: '会员方案加载失败',
      monthly: '按月',
      yearly: '按年',
      discountTag: '-{percent}%',
      month: '月',
      year: '年',
      currentPlan: '当前方案',
      selectPlan: '请选择会员方案',
      backToPlans: '返回方案选择',
      badgeFree: 'FREE',
      badgeLite: 'LITE',
      badgePro: 'PRO',
      badgeVip: 'VIP',
      timeHourMinute: '{hours}小时 {minutes}分钟',
      feature: {
        marketBrowse: '市场浏览',
        traderDetail: '交易员详情',
        hotMarketData: '热门市场数据',
        leaderboard: '牛人榜列表',
        autoCopyRisk: '自动跟单与风控',
        allFree: '所有 Free 功能',
        allLite: '所有 Lite 功能',
      },
    },
    points: {
      balance: '点数',
      buy: '购买点数',
      buyTitle: '购买点数',
      buySubtitle: 'POINTS',
      packageTitle: '点数套餐',
      minTopupHint: '最低充值金额为 {min}U',
      minTopupShort: '最低 {min}U',
      estimated: '预计获得 {points} 点',
      topupSuccess: '点数已到账',
    },
    redemption: {
      haveCode: '有兑换码？',
      placeholder: '输入兑换码',
      validate: '验证',
      redeem: '兑换',
      invalidCode: '兑换码无效',
      validateFailed: '验证失败，请稍后重试',
      redeemFailed: '兑换失败，请稍后重试',
      success: '🎉 兑换成功！会员已激活',
      preview: '可兑换 {tier} 会员 {months} 个月',
    },
    payment: {
      selectNetwork: '选择支付网络',
      network: '网络',
      token: '代币',
      summary: '支付摘要',
      creating: '创建订单中...',
      amount: '支付金额',
      expiresIn: '剩余时间',
      payAddress: '收款地址',
      payUri: '支付链接',
      refreshStatus: '刷新状态',
      statusLabel: '当前状态',
      waitingPayment: '请完成链上转账以升级会员',
      successTitle: '支付成功',
      successDesc: '会员已升级，请返回查看',
      done: '完成',
      upgradeSuccess: '会员升级成功',
      statusRefreshFailed: '状态刷新失败，请稍后重试',
      optionsLoadFailed: '支付选项加载失败',
      createFailed: '创建支付订单失败',
      statusPending: '等待支付',
      statusConfirming: '确认中',
      statusUnderpaid: '金额不足',
      statusConfirmed: '已确认',
      statusSettling: '结算中',
      statusSettled: '已完成',
      statusExpired: '已过期',
      statusFailed: '支付失败',
      qrWaiting: '二维码生成中...',
      autoRefresh: '自动刷新 {seconds}s',
    },
    customName: {
      title: '自定义名称',
      subtitle: 'CUSTOM NAME',
      hint: '仅对你可见，用于更好地识别交易员或策略。',
      targetLabel: '目标',
      placeholder: '输入自定义名称',
      limit: '最多 {max} 个字符',
      saving: '保存中...',
      clear: '清除',
      edit: '自定义名字',
      saveSuccess: '已更新自定义名称',
      clearSuccess: '已清除自定义名称',
      saveFailed: '保存失败，请稍后重试',
      clearFailed: '清除失败，请稍后重试',
      loginRequired: '请先登录再设置自定义名称',
    },
    toast: {
      comingSoon: '{feature} 功能敬请期待',
      quickTradeOpened: '已跳转至快捷交易通道（Telegram）进行下单',
      quickTradeInvalid: '当前市场无有效标识，无法跳转',
      favoriteAdded: '已添加到收藏',
      favoriteRemoved: '已取消收藏',
      operationFailed: '操作失败，请稍后重试',
      inviteVerifiedWelcome: '验证成功，欢迎使用 PolyOne!',
    },
    actions: {
      aiInsights: 'AI 洞察',
      quickTrade: '快捷交易',
      favorited: '已收藏',
      addFavorite: '加入收藏',
      shareMarket: '分享市场',
    },
    header: {
      navToggle: '打开/关闭导航栏',
      searchPlaceholder: '搜索市场、交易员或事件...',
      searching: '搜索中...',
      viewAddress: '查看地址',
      viewThisAddress: '查看此地址',
      traders: '交易员',
      markets: '市场',
      noResults: '未找到相关结果',
      feedback: '问题反馈',
      joinTgGroup: '加入 Telegram 群',
      tgGroupTitle: '加入用户群',
      tgGroupDesc: '点击加入 @polyone_ai 获取最新动态和交流',
      switchLang: '切换语言',
      balanceLoading: '余额加载中...',
      balance: '余额',
      settings: '设置',
      setInterests: '设置兴趣类别',
      boundEmail: '绑定邮箱',
      bindEmail: '绑定邮箱',
      changeEmail: '修改邮箱',
    },
    auth: {
      loginRequiredTitle: '请先登录',
      loginRequiredDesc: '登录后即可查看您的持仓信息',
      authExpired: '认证已过期，请重新登录',
    },
    tgLogin: {
      missingParams: '登录参数缺失，请重新登录',
      loadingTitle: '正在登录...',
      loadingDesc: '请稍候，我们正在验证您的身份',
      successTitle: '登录成功!',
      successDesc: '即将跳转到首页...',
      errorTitle: '登录失败',
      errorDesc: '将在 3 秒后返回首页...',
    },
    positions: {
      loading: '正在加载持仓数据...',
      loadFailed: '加载失败',
      fetchFailed: '获取持仓失败',
      emptyTitle: '我的持仓',
      emptyHint: '您当前没有任何持仓。去"推荐"里看看感兴趣的市场吧～',
      positions: '持仓',
      roi: 'ROI',
      wallet: '钱包',
      all: '全部',
      current: '当前',
      settled: '已结算',
      pageKicker: 'POSITIONS',
      pageSubtitle: '管理您的预测市场投资组合',
      refresh: '刷新',
      refreshShort: '刷新',
      totalValue: '总资产价值',
      totalUnrealizedPnl: '总浮动盈亏',
      totalPnlTooltip: '总浮动盈亏 = 已结算盈亏 + 未赎回盈亏 + 进行中浮动盈亏',
      openPositions: '活跃持仓',
      openPositionsLabel: '进行中持仓',
      historicalWinRate: '历史胜率',
      walletList: '钱包列表',
      walletCount: '个钱包',
      active: '使用中',
      selectWallet: '选择钱包',
      filterByStatus: '筛选状态',
      items: '条',
      positionsDetail: '持仓明细',
      walletRow: '持仓: {positions} | 余额: {cash}',
      emptyWalletTitle: '该钱包暂无持仓',
      emptyWalletDesc: '去发现一些有趣的市场吧',
      noOpen: '暂无正在进行的持仓',
      noUnredeemed: '暂无未赎回的持仓',
      noSettled: '暂无已结算的持仓',
      noHistoryTitle: '暂无历史持仓记录',
      noHistoryDesc: '您的已结算持仓将显示在这里',
      settledTotal: '已结算总数',
      winRate: '胜率',
      realizedPnl: '已实现盈亏',
      statusUnredeemed: '未赎回',
      statusClosed: '已结束',
      statusSettled: '已结算',
      statusActive: '进行中',
      marketUnknown: '未知市场',
      currentValue: '当前价值',
      settledValue: '结算金额',
      pnlFloating: '浮动盈亏',
      pnlWin: '获得收益',
      pnlLoss: '产生亏损',
      settledResult: '结算结果',
      realizedProfit: '已实现收益',
      realizedLoss: '已实现亏损',
      positionSize: '持仓数量',
      avgPrice: '均价',
      currentPrice: '当前价',
      buyAvgPrice: '买入均价',
      marketResult: '市场结果',
      settleTime: '结算时间',
      investedCost: '投入成本',
      yesterdayPnl: '昨日盈亏',
      weekPnl: '本周盈亏',
      monthPnl: '本月盈亏',
      allTimePnl: '历史总盈亏',
      yesterday: '昨日',
      thisWeek: '本周',
      thisMonth: '本月',
      allTime: '历史',
      tradeSource: '交易来源',
      sellAction: '卖出',
      sellPreparing: '卖出中...',
      sellGenerating: '正在生成卖出链接...',
      sellOpened: '已跳转到机器人确认卖出',
      sellFailed: '卖出失败',
      sellSubmitting: '正在提交卖出...',
      sellSuccess: '卖出已提交',
      sellConfirmTitle: '确认卖出',
      sellConfirmSubtitle: '持仓卖出',
      sellConfirmTip: '确认后将卖出该持仓的全部数量，价格以订单簿为准。',
      sellConfirmAction: '确认卖出',
      sellConfirmWallet: '钱包',
      sellConfirmSize: '卖出数量',
      outcome: '方向',
      market: '市场',
      action: '操作',
      pnl: '盈亏',
      status: '状态',
    },
    invite: {
      verifying: '验证邀请码中...',
      invalidTitle: '邀请码无效',
      verifyFailed: '验证邀请码失败,请稍后重试',
      welcome: '欢迎加入 {brand}',
      inviteCode: '邀请码',
      tagline: 'AI 驱动的预测市场平台\n实时跟单顶级交易员',
      joinViaTelegram: '使用 Telegram 加入',
      firstLoginHint: '首次登录将自动创建账户',
    },
    share: {
      invalidTarget: '分享链接包含非法目标地址',
      invalidLink: '分享链接无效',
      loadFailed: '加载分享链接失败',
      redirectingHome: '正在跳转到首页...',
      redirecting: '正在跳转...',
    },
    notFound: {
      title: '页面未找到',
      desc: '您访问的页面不存在，或已被移动到其他位置。',
    },
    leaderboard: {
      title: '牛人榜',
      kicker: 'LEADERBOARD',
      subtitle: '聚合多个维度榜单，快速发现稳定盈利的交易员，并支持地址直达。',
      lockedTitle: '牛人榜仅对会员开放',
      lockedDesc: '升级会员即可查看完整排行榜、AI评分与跟单入口。',
      lockedHint: '已是会员？刷新会员状态即可解锁。',
      boards: {
        rov: 'ROV 榜',
        pnl: '盈利榜',
        winRate: '胜率榜',
        trades: '交易数榜',
        active: '活跃榜',
      },
      boardDesc: {
        rov: '按近30天 ROV 排序，衡量近期收益能力。',
        pnl: '按近30天累计盈利排序，偏重近期总利润。',
        winRate: '按近30天胜率排序，偏重近期稳定性。',
        trades: '按近30天交易次数排序，偏重近期活跃度。',
        active: '按最近活跃时间排序，偏重新鲜度。',
      },
      addressSearchTitle: '地址直达',
      addressSearchPlaceholder: '输入交易员地址 (0x...)',
      addressSearchAction: '查看地址',
      addressSearchHint: '支持输入完整地址，直接打开交易员详情页。',
      addressInvalid: '请输入有效的以太坊地址',
    },
    leaderboardTable: {
      domainFilter: '领域过滤',
      clearFilter: '清空筛选',
      domainSearchPlaceholder: '搜索感兴趣的领域...',
      categoryFilter: '分类筛选',
      categorySports: '体育',
      categoryPolitics: '政治',
      categoryCrypto: '加密货币',
      categoryHint: '当前仅开放 NBA，其它领域即将上线。',
      soon: '即将',
      leagueSoccer: '足球',
      discoveredTraders: '已发现 {count} 位优质交易员',
      shareLeaderboard: '分享榜单',
      refresh: '刷新列表',
      share: '分享',
      portfolioCopyTop10: '组合跟单（Top 10）',
      portfolioCopyLoading: '配置中...',
      portfolioCopyNone: '暂无可跟单的交易员',
      portfolioCopyOpened: '已跳转至组合跟单机器人（{count}位交易员）',
      portfolioRiskTitle: '组合跟单风险提示',
      portfolioRiskSubtitle: 'PORTFOLIO RISK',
      portfolioRiskConfirmTitle: '检测到可疑地址',
      portfolioRiskDesc: 'Top 10 中有 {count} 个地址疑似高频机器人或做市商。可选择仅跟单其它地址，或继续跟单全部地址。',
      portfolioRiskListTitle: '可疑地址',
      portfolioRiskListCount: '{count} 个',
      portfolioRiskCancel: '取消跟单',
      portfolioRiskFollowSafe: '仅跟单安全地址',
      portfolioRiskContinue: '继续跟单全部',
      portfolioRiskNoSafe: '没有可跟单的安全地址',
      shareNeedLogin: '请先登录后再使用分享功能',
      copyNeedLogin: '请先登录后再使用跟单功能',
      shareCopied: '分享链接已复制到剪贴板',
      linkCopied: '已复制链接',
      shareCreateFailed: '生成分享链接失败，请稍后重试',
      leaderboardLoadFailed: '排行榜数据加载失败，请稍后重试',
      follow: '跟单',
      generatingConfig: '正在生成跟单配置...',
      followCreateFailed: '创建跟单配置失败',
      winRate: '近30天胜率',
      totalProfit: '近30天总盈利',
      lastActive: '活跃时间',
      justNow: '刚刚',
      secondsAgo: '{n}秒前',
      minutesAgo: '{n}分钟前',
      hoursAgo: '{n}小时前',
      daysAgo: '{n}天前',
      trades: '近30天交易数',
      tradesCount: '近30天交易次数',
      botTag: '机器人',
      botRiskTitle: 'AI 风险提示',
      botRiskSubtitle: 'AI RISK',
      botRiskConfirmTitle: '确认继续跟单？',
      botRiskDesc: '该交易员地址（{name}）经 AI 分析可能为{type}，跟单存在风险。是否继续？',
      botRiskCancel: '取消',
      botRiskConfirm: '继续跟单',
      tradingStyle: '交易风格',
      suspectedRobot: '疑似高频机器人',
      suspectedMarketMaker: '疑似做市商',
      rank: '排名',
      trader: '交易员',
      domains: '擅长领域',
      actions: '操作',
      analyzing: '正在分析链上数据...',
      noTraders: '暂无符合条件的交易员',
      sorting: '排序',
      asc: '升序',
      desc: '降序',
      aiScore: 'AI评分',
      aiScoreHint: '基于交易历史与风控表现的综合评分',
    },
    customName: {
      title: '自定义名称',
      subtitle: 'CUSTOM NAME',
      hint: '为当前配置设置一个易于识别的名称',
      targetLabel: '目标',
      placeholder: '输入自定义名称',
      limit: '最多 {max} 个字符',
      saveSuccess: '名称已保存',
      saveFailed: '保存失败',
      clearSuccess: '名称已清除',
      clearFailed: '清除失败',
      saving: '保存中...',
      clear: '清除',
    },
    leaderboardSidebar: {
      tabLeaderboard: '排行榜',
      tabInsightsSoon: '洞察（即将开放）',
      tabSoonToast: '该功能即将上线，敬请期待',
      smartMoney: 'Smart Money',
      title: '牛人榜',
      lastActive: '最新活跃',
      totalProfit: '近30天总盈利',
      winRate: '近30天胜率',
      volume: '近30天交易量',
      domainLabel: '领域',
      uncategorized: '未分类',
      activeOn: '活跃 {date}',
      viewDetail: '查看详情',
      totalTrades: '近30天交易 {count} 场',
      generatingConfig: '正在生成跟单配置...',
      botNotConfigured: '暂未配置跟单机器人，请稍后重试',
      jumpToBot: '已跳转至跟单机器人（Telegram）',
      createFailed: '创建跟单配置失败，请稍后重试',
      domainFilter: '领域过滤',
      clear: '清空',
      searchPlaceholder: '搜索交易员地址或用户名',
      domainSearchPlaceholder: '查找领域',
      noMatchedDomains: '暂无匹配的领域',
      noSmartMoney: '暂无符合条件的聪明钱',
    },
    smartMoneyTrades: {
      title: '实时聪明钱交易',
      monitoring: '实时监控中',
      disconnected: '连接断开',
      live: '实时中',
      paused: '暂停中',
      close: '关闭',
      noTrades: '暂无实时交易',
      scanning: 'AI 正在扫描链上数据...',
      copyTrade: '复制交易',
      followTrader: '跟单牛人',
      copyAddress: '复制地址',
      addressCopied: '交易员地址已复制',
      jumpedToCopy: '已跳转至 Telegram Bot 复制交易',
      generatingConfig: '正在生成跟单配置...',
      jumpedToFollow: '已跳转至 Telegram Bot 跟单',
      createConfigFailed: '创建跟单配置失败',
      createConfigFailedRetry: '创建跟单配置失败，请稍后重试',
      rov: 'ROV',
      winRate: '胜率',
      profit: '盈利',
      prediction: '预测',
      price: '价格',
      quantity: '数量',
      totalValue: '总值',
      option: '选项',
      amount: '金额',
      justNow: '刚刚',
      secondsAgo: '{n}秒前',
      minutesAgo: '{n}分钟前',
      hoursAgo: '{n}小时前',
      daysAgo: '{n}天前',
      footerText: '已显示 {count} 条实时交易 · 最多保留 50 条',
      floatingButton: '实时聪明钱交易',
    },
    copyConfigModal: {
      title: '配置跟单',
      subtitle: 'COPY CONFIG',
      defaultName: '跟单 {name}',
      portfolioDefaultName: '组合跟单 {count} 人',
      defaultNameFallback: '跟单配置',
      portfolioTitle: '组合跟单',
      portfolioCount: '共 {count} 位交易员',
      addressesLabel: '跟单地址',
      unknownTrader: '未知交易员',
      copyAddress: '复制地址',
      copyAllAddresses: '复制全部地址',
      addressCopied: '地址已复制',
      addressesCopied: '地址已复制',
      copyFailed: '复制失败',
      winRate: '胜率',
      totalProfit: '累计盈利',
      aiScore: 'AI 评分',
      tradingStyle: '交易风格',
      nameLabel: '跟单名称',
      namePlaceholder: '为该跟单命名',
      nameRequired: '请输入跟单名称',
      nameTooLong: '名称长度超出限制',
      amountLabel: '单市场金额 (USDC)',
      amountPlaceholder: '例如 10',
      amountInvalid: '金额需不小于 1',
      amountHint: '单笔跟单投入金额',
      advancedSettings: '高级设置',
      investmentLimitLabel: '投资总额上限 (USDC)',
      investmentLimitPlaceholder: '留空表示不限',
      investmentLimitInvalid: '请输入有效的金额 (>=1)',
      investmentLimitTooLow: '总额上限需不小于单市场金额',
      investmentLimitHint: '可选，限制总投入',
      copySideLabel: '跟单方向',
      copySideBuySell: '买入 + 卖出',
      copySideBuyOnly: '仅买入',
      copySideHint: '选择是否跟随卖出',
      stopLossLabel: '止损金额设置',
      stopLossOn: '已开启',
      stopLossOff: '已关闭',
      stopLossPlaceholder: '留空自动计算',
      stopLossInvalid: '止损阈值需大于等于 1',
      stopLossHint: '留空则按默认比例自动计算',
      marketCooldownLabel: '同市场同方向冷却',
      marketCooldownOn: '已开启',
      marketCooldownOff: '已关闭',
      marketCooldownPlaceholder: '分钟数，默认 3',
      marketCooldownInvalid: '冷却分钟数需为 {min}~{max} 的整数',
      marketCooldownTooltip: '开启后，同一策略在冷却时间内不会重复买入同一市场同一方向',
      marketCooldownHint: '开启后，同一市场同一方向在冷却窗口内不会重复买入',
      minuteUnit: '分钟',
      creating: '创建中...',
      confirm: '创建跟单',
      createSuccess: '跟单配置已创建',
      createFailed: '创建跟单配置失败',
    },
    copyTrading: {
      loadFailed: '加载跟单配置失败',
      membershipRequiredDesc: '该功能仅对会员开放，升级后即可管理跟单与风控设置。',
      refreshed: '已刷新',
      invalidLossLimit: '请输入有效的亏损上限（>0），或留空表示无上限',
      globalRiskUpdated: '全局风控已更新',
      globalRiskUpdateFailed: '更新全局风控失败',
      autoCopyResumed: '已恢复账号自动跟单',
      resumeFailed: '恢复失败',
      invalidInvestmentLimit: '请输入有效的投资总金额（>0），或留空表示无上限',
      invalidStopLossLimit: '止损阈值请输入有效数字（>=1），或留空表示自动计算',
      invalidMarketCooldownMinutes: '冷却分钟数需为 {min}~{max} 的整数',
      strategyRiskUpdated: '策略风控已更新',
      strategyRiskUpdateFailed: '更新策略风控失败',
      autoCopyOn: '自动跟单已开启',
      autoCopyOff: '自动跟单已关闭',
      operationFailed: '操作失败',
      deleteConfirm: '确定要删除此跟单配置吗？',
      deleteFailed: '删除失败',
      deletedOk: '配置已删除',
      selectConfig: '选择一个跟单配置',
      selectConfigDesc: '查看详情并管理您的跟单机器人',
      pause: '暂停',
      enable: '启用',
      risk: '风控',
      delete: '删除',
      createdAt: '创建时间',
      lastTriggeredAt: '上次触发',
      totalTrades: '累计交易',
      unmatchedTrades: '有 {count} 笔未匹配到持仓',
      realizedPnl: '已实现盈亏',
      winRate: '胜率',
      winsLosses: '{wins} 胜 / {losses} 负',
      amountPerTrade: '单笔金额',
      riskSettings: '风控设置',
      copySide: '跟单方向',
      copySideBuyOnly: '仅跟买单',
      copySideBuySell: '跟买单 + 跟卖单',
      investmentLimit: '投资总金额上限',
      unlimited: '无上限',
      stopLoss: '策略止损',
      stopLossAuto: '自动计算（默认 50%）',
      disabled: '未启用',
      stopLossTriggered: '已触发策略止损，自动跟单已暂停',
      reason: '原因：',
      copyingTraders: '正在跟单 {count} 位交易员',
      pageKicker: '跟单管理',
      pageTitle: '我的跟单配置',
      refreshTitle: '刷新数据',
      systemOnline: '系统在线',
      globalRiskTitle: '全局跟单风控',
      status: '状态',
      paused: '已暂停',
      normal: '正常',
      lossLimit: '亏损上限',
      pageXofY: '第 {page} / {total} 页',
      settledDesc: '市场结算后会出现在这里',
      resume: '恢复',
      edit: '修改',
      statTotalConfigs: '配置总数',
      statAutoCopy: '自动跟单',
      statTotalTrades: '总交易次数',
      globalModalDesc:
        '设置账号级的最大亏损上限。当总亏损达到此金额时，将暂停所有自动跟单任务，保护您的本金安全。\n留空则表示不设上限。',
      lossLimitLabel: '亏损上限 (USDC)',
      lossLimitPlaceholder: '例如 200',
      saveSettings: '保存设置',
      strategyModalTitle: '策略风控设置',
      investmentLimitLabelWithUnit: '投资总金额上限 (USDC)',
      investmentLimitPlaceholder: '留空=无上限，例如 500',
      investmentLimitHint: '此配置允许投入的最大本金总额。',
      stopLossTitle: '策略止损',
      stopLossHint: '仅统计已结算市场亏损，最小止损 $1',
      stopLossThresholdLabel: '止损阈值 (USDC)',
      stopLossThresholdPlaceholder: '留空=自动计算，例如 20',
      stopLossAutoHint:
        '留空则在下一次结算时按默认比例 50% 自动计算并锁定为固定阈值（最小 $1）。',
      configLabel: '配置',
      loading: '加载中...',
      positionsLoading: '加载持仓数据...',
      openPositionsTitle: '进行中持仓',
      positionsCount: '{count} 个持仓',
      noMatchedPositions: '暂无匹配到的持仓',
      noMatchedHint: '等待交易执行后刷新',
      closedPositionsTitle: '已结算持仓',
      closedPositionsCount: '{count} 个已结算',
      noClosedPositions: '暂无已结算持仓',
      directionTrades: '方向: {direction} · 交易 {count} 次',
      settlementTime: '结算时间',
      cost: '成本',
      currentValue: '现值',
      settledValue: '结算金额',
      pnl: '盈亏',
      currentPrice: '当前价格',
      loadingConfigs: '正在加载跟单配置...',
      noConfigs: '暂无配置',
      configList: '配置列表',
      traderUnit: '交易员',
      tradeUnit: '笔交易',
      tradersCount: '{count} 交易员',
      tradesCount: '{count} 笔交易',
      allDomains: '全领域',
      pauseGlobal: '暂停跟单',
      pauseGlobalConfirm: '确定要暂停全局跟单吗？这将关闭所有自动跟单配置。',
      pauseGlobalOk: '已暂停全局跟单',
      pauseGlobalFailed: '暂停失败',
      resumeGlobalOk: '已恢复账号自动跟单',
      reasonInsufficientBalance: '余额不足：当前 {current}，需要 {required}',
      reasonLossLimit: '达到亏损上限',
      reasonManual: '用户手动暂停',
      pauseReasonInsufficientBalance: '余额不足',
      pauseReasonInsufficientPoints: '点数不足',
      pauseReasonManual: '手动暂停',
      autoOn: '自动开启',
      autoOff: '自动关闭',
      unnamedConfig: '未命名配置',
      noConfigSelected: '未选择配置',
      selectConfigPrompt: '请从左侧列表选择一个跟单配置查看详情',
      loadingDetail: '正在加载详情...',
      configDetail: '配置详情',
      editName: '编辑名称',
      off: '关闭',
      traders: '交易员',
      unknownMarket: '未知市场',
      openedAt: '开仓时间',
      closedAt: '结算时间',
      investmentLimitLabel: '投资限额',
      stopLossEnabled: '启用止损',
      stopLossLimitPlaceholder: '止损阈值',
      marketCooldownEnabled: '同市场同方向冷却',
      marketCooldownMinutesPlaceholder: '冷却分钟数（默认 3）',
      marketCooldownDesc: '开启后，同一策略在冷却时间内不会重复买入同一市场同一方向',
      minuteUnit: '分钟',
      strategyRiskTitle: '策略风控',
      openPositions: '进行中持仓',
      closedPositions: '已结算持仓',
      tradersList: '交易员列表',
      viewTrader: '查看',
      noOpenPositions: '暂无进行中持仓',
      noClosedPositions: '暂无已结算持仓',
      tradeHistory: '交易流水',
      tradeHistoryDesc: '显示所有跟单交易记录',
      noTrades: '暂无交易记录',
      noTradesHint: '开启自动跟单后，交易记录将出现在此处',
      actionBuy: '买入',
      actionSell: '卖出',
      tradeAmount: '金额',
      tradePrice: '价格',
      tradeShares: '份额',
      tradeTime: '时间',
      tradeTrader: '源交易员',
      loadTradesFailed: '加载交易流水失败',
    },
    wallets: {
      loginRequiredTitle: '请先登录',
      loginRequiredDesc: '登录后即可查看您的钱包列表',
      loading: '正在加载钱包数据...',
      loadFailed: '加载失败',
      fetchFailed: '获取数据失败',
      addressCopied: '地址已复制到剪贴板',
      copyFailed: '复制失败',
      setTradingWalletOk: '已设置为主交易钱包',
      setFailed: '设置失败',
      exportFailed: '导出失败',
      requestFailed: '请求失败',
      tradingWalletCannotDelete: '主交易钱包不能被删除，请先将其切换为非主钱包',
      deleteWalletConfirm: '确定要移除该钱包吗？移除后将无法在列表中看到，且无法恢复显示（除非联系管理员）。',
      walletRemoved: '钱包已移除',
      removeFailed: '移除失败',
      invalidWalletAddress: '请输入有效的钱包地址',
      whitelistAdded: '已添加到白名单',
      addFailed: '添加失败',
      whitelistRemoved: '已从白名单移除',
      removeWhitelistConfirm: '确定要从白名单移除 {address} 吗？',
      walletManagement: '钱包管理',
      title: '💼 您的钱包列表',
      refreshTitle: '刷新数据',
      manageWhitelist: '管理白名单',
      noWallets: '您还没有任何钱包',
      walletLabel: '钱包 {label}',
      systemCreated: '系统创建',
      userImported: '用户导入',
      createdAt: '创建于',
      setAsTradingWallet: '设为交易钱包',
      setAsPrimary: '设为主钱包',
      deposit: '转入',
      withdraw: '转出',
      removeWallet: '移除钱包',
      totalUsdc: 'USDC 总资产',
      totalPol: 'POL 总资产',
      walletCount: '钱包数量',
      tradingWallet: '主交易钱包',
      notSet: '未设置',
      active: '活跃',
      inactive: '未激活',
      mainWallet: '主钱包',
      walletList: '钱包列表',
      usdcBalance: 'USDC 余额',
      polBalance: 'POL 余额',
      noWalletsHint: '系统将自动为您创建第一个钱包',
    },
    whitelist: {
      title: '管理提现白名单',
      subtitle: 'Withdrawal Whitelist',
      intro: '资金只能提现到白名单内的地址。白名单为空时也无法提现，请先添加安全地址。',
      hint: '建议添加常用的交易所或冷钱包地址以提高安全性。',
      placeholder: '输入 Polygon (0x...) 钱包地址',
      add: '添加',
      remove: '移除',
      empty: '暂无白名单地址，当前无法提现',
      list: '白名单列表',
      addresses: '个地址',
    },
    deposit: {
      title: '充值资产',
      warningTitle: '请务必注意',
      warningLine1: '请仅通过 Polygon (PoS) 网络充值。',
      warningLine2: '充值其他网络资产可能导致永久丢失。',
      copyAddress: '地址已复制',
      saveQr: '保存二维码',
      copiedImage: '已复制图片',
      qrCopied: '二维码图片已复制',
      imageGenFailed: '生成图片失败',
      imageCopyFailed: '复制图片失败，请尝试截图',
      imageGenError: '生成图片出错',
      depositAddress: '充值地址 (Polygon)',
      tradingFunds: '交易资金',
      gasFee: 'Gas 费',
    },
    withdraw: {
      title: '转出资金',
      fromWallet: '从钱包',
      token: '币种',
      amount: '金额',
      balance: '余额',
      max: '最大',
      toAddress: '收款地址',
      safeHint: 'Safe 钱包转账仅支持 USDC，且无需支付 Gas 费（由 Relayer 代付）。',
      eoaHint: 'EOA 钱包转账需要少量 POL 作为 Gas 费。',
      cancel: '取消',
      confirm: '确认转出',
      submitOk: '转账请求已提交，等待确认',
      success: '转账成功',
      failed: '转账失败',
      timeout: '转账确认超时，请稍后查看状态',
      fillAll: '请填写完整信息',
      invalidTo: '请输入有效的收款地址',
      amountGt0: '转账金额必须大于 0',
    },
    privateKey: {
      title: '导出私钥',
      copied: '私钥已复制到剪贴板',
      warningTitle: '⚠️ 安全警告',
      warningLine1: '私钥是您资产的唯一凭证。请勿将私钥透露给任何人，包括官方客服。',
      warningLine2: '一旦丢失或泄露，您的资产将无法找回。',
      yourKey: '您的私钥',
      hide: '隐藏',
      show: '显示',
      copy: '复制',
      copiedShort: '已复制',
      close: '关闭',
    },
    inviteManage: {
      loginRequiredTitle: '请先登录',
      loginRequiredDesc: '登录后即可查看您的专属邀请码和邀请记录',
      loading: '正在加载数据...',
      noCodeTitle: '暂无邀请码',
      noCodeDesc: '请联系管理员获取邀请权限',
      unavailableTitle: '功能暂未开放',
      unavailableDesc: '邀请功能暂时无法使用',
      copiedLink: '邀请链接已复制到剪贴板',
      copiedMessage: '邀请信息已复制，可直接分享给好友',
      messageTemplate:
        '🎁 邀请你加入 {brand}！\n\nAI 驱动的预测市场平台，实时跟单顶级交易员\n\n我的邀请码：{code}\n\n通过 Telegram 加入（推荐）：\n{telegramLink}\n\n或访问 Web 应用：\n{webLink}',
      pageTitle: '邀请好友',
      pageDesc: '分享您的专属邀请码，邀请好友加入 {brand}，一起探索预测市场。',
      yourCode: '我的邀请码',
      codeCopied: '邀请码已复制',
      copy: '复制',
      yourCredential: '您的专属邀请凭证',
      invitedFriends: '已邀请好友',
      invitedCountDesc: '累计成功邀请人数',
      shareMethods: '分享方式',
      telegramInvite: 'Telegram 邀请链接',
      telegramInviteDesc: '生成 Telegram Bot 专属邀请链接，推荐使用',
      webInvite: 'Web 邀请链接',
      webInviteDesc: '生成网页版注册链接，适合在浏览器中分享',
      messageInvite: '邀请文案',
      messageInviteDesc: '一键复制完整邀请文案，适合转发到任意平台',
      copied: '已复制',
      copyLink: '复制链接',
      copyText: '复制文案',
      historyTitle: '邀请记录',
      recentN: '最近 {count} 条',
      unknownUser: '未知用户',
      noInvites: '暂无邀请记录',
      noInvitesHint: '快去分享您的邀请码吧！',
      activity: '邀请活跃度',
      keepSharing: '继续分享获得更多奖励',
    },
    inviteCodeModal: {
      needCode: '请输入 6 位邀请码',
      invalid: '邀请码无效',
      verifyFailed: '验证失败，请重试',
      titleInput: '请输入邀请码',
      titleSuccess: '验证成功',
      subtitleInput: 'PolyOne 目前处于内测阶段，需要邀请码才能使用',
      subtitleSuccess: '欢迎使用 PolyOne！',
      redirecting: '正在跳转...',
      verifying: '验证中...',
      verifyButton: '验证邀请码',
      noCodeHint: '没有邀请码？请联系已注册用户获取邀请码',
      otherAccount: '使用其他账号登录',
      ariaInput: '请输入6位邀请码',
    },
    loginModal: {
      kicker: '用户认证',
      title: '登录 {brand}',
      closeAria: '关闭登录弹窗',
      desc: '通过 Telegram 快速登录，无需注册，安全便捷。',
      button: '使用 Telegram 登录',
      hint: '点击后将跳转到 Telegram，\n机器人会发送登录链接给您',
      terms: '登录即表示您同意我们的服务条款和隐私政策。\n首次登录将自动创建账户。',
      telegramTab: 'Telegram',
      emailTab: '邮箱',
      switchToEmail: '通过邮箱登录',
      switchToTelegram: '通过 Telegram 登录',
      or: '或',
      emailTitle: '邮箱登录',
      emailLabel: '邮箱地址',
      emailPlaceholder: '请输入邮箱',
      emailCaptchaLabel: '图片验证码',
      emailCaptchaPlaceholder: '输入图片验证码',
      emailCaptchaRefresh: '点击刷新验证码',
      emailCodeLabel: '邮箱验证码',
      emailCodePlaceholder: '输入邮箱验证码',
      emailSendCode: '发送验证码',
      emailLoginAction: '邮箱登录',
      emailLogging: '登录中...',
      emailRequired: '请先填写邮箱',
      emailCaptchaRequired: '请先填写图片验证码',
      emailCodeRequired: '请输入邮箱验证码',
      emailCodeSent: '验证码已发送',
      emailSendFailed: '发送验证码失败',
      emailLoginFailed: '邮箱登录失败',
      emailCaptchaFailed: '获取验证码失败',
    },
    emailBind: {
      title: '绑定邮箱',
      subtitle: 'EMAIL BINDING',
      desc: '为了保障账户安全，请先绑定邮箱。',
      emailLabel: '邮箱地址',
      emailPlaceholder: '请输入邮箱',
      captchaLabel: '图片验证码',
      captchaPlaceholder: '输入图片验证码',
      captchaRefresh: '点击刷新验证码',
      captchaLoading: '加载中...',
      captchaFailed: '获取验证码失败',
      emailRequired: '请先填写邮箱',
      captchaRequired: '请先填写图片验证码',
      codeLabel: '邮箱验证码',
      codePlaceholder: '输入邮箱验证码',
      sendCode: '发送验证码',
      resendIn: '{n}s 后重试',
      sendSuccess: '验证码已发送',
      sendFailed: '发送验证码失败',
      codeRequired: '请输入邮箱验证码',
      bindSuccess: '邮箱绑定成功',
      bindFailed: '邮箱绑定失败',
      cancel: '稍后再说',
      confirm: '确认绑定',
      binding: '绑定中...',
      securityTip: '您的邮箱将用于账户安全验证和重要通知',
    },
    traderDetail: {
      backToPrevious: '返回上一页',
      anonymousTrader: '匿名交易员',
      traderDescription: '该交易员在 PolyOne 上的历史表现与持仓分析。',
      share: '分享',
      copyTrade: '跟单',
      winRate: '胜率',
      totalPnl: '累计PnL',
      totalVolume: '累计交易额',
      last30dBadge: '近30天',
      domainDistribution: '领域分布',
      performanceAnalysis: '绩效走势分析',
      riskMetrics: '风险分析',
      periodDay: '日',
      periodWeek: '周',
      periodMonth: '月',
      totalInvested: '总投入',
      totalReturn: '总回报',
      volatility: '波动率',
      maxDrawdown: '最大回撤',
      sharpeRatio: '夏普比率',
      currentPositions: '当前持仓',
      activityTitle: '交易活动',
      activitySubtitle: 'ACTIVITY',
      activityRecords: '{count} 条',
      activityEmpty: '暂无活动记录',
      activityEmptyDesc: '当前没有可展示的活动记录',
      activityLoadMore: '加载更多',
      activityValue: '金额',
      activityPrice: '成交价',
      activitySize: '数量',
      activityTx: '交易哈希',
      activityTypeTrade: '交易',
      activityTypeRedeem: '赎回',
      activityTypeMerge: '合并',
      activityTypeSplit: '拆分',
      activityTypeReward: '奖励',
      activityTypeConversion: '转换',
      activitySideBuy: '买入',
      activitySideSell: '卖出',
      positionsOngoing: '{count} 笔进行中',
      deadline: '截止',
      invested: '投入',
      currentValue: '现值',
      noPositions: '暂无公开持仓',
      tradeHistory: '交易历史',
      showingRecent: '显示最近 {count} 笔',
      market: '市场',
      direction: '方向',
      pnl: '盈亏',
      noHistory: '暂无交易历史',
      loadFailed: '加载失败',
      loadDetailFailed: '加载交易员详情失败，请稍后重试',
      membershipRequiredDesc: '该页面仅对会员开放，升级后即可查看交易员完整数据。',
      pointsInsufficientTitle: '点数不足',
      pointsInsufficientDesc: '解锁该交易员详情需要消耗点数。',
      pointsInsufficientHint: '升级会员或补充点数后可继续查看。',
      pointsBalanceLabel: '当前点数',
      noTrendData: '暂无走势数据',
      noDistribution: '暂无分布',
      cumulativePnl: '累计盈亏',
      shareRatio: '占比',
      shareNeedLogin: '请先登录后再使用分享功能',
      shareCopied: '分享链接已复制到剪贴板',
      shareUnavailable: '分享功能暂时不可用',
      copyNeedLogin: '请先登录后再使用跟单功能',
      botNotConfigured: '暂未配置跟单机器人，请稍后重试',
      generatingConfig: '正在生成跟单配置...',
      jumpedToBot: '已跳转至跟单机器人',
      createConfigFailed: '创建跟单配置失败',
      createConfigFailedRetry: '创建跟单配置失败，请稍后重试',
      botRiskTitle: 'AI 风险提示',
      botRiskSubtitle: 'AI RISK',
      botRiskDesc: '该交易员地址（{name}）经 AI 分析可能为{type}，跟单存在风险。是否继续？',
      botRiskCancel: '取消',
      botRiskConfirm: '继续跟单',
      aiAnalysisTitle: 'AI 分析',
      aiAnalysisSubtitle: 'TRADER INSIGHT',
      aiAnalysisLoading: 'AI 正在分析交易员...',
      aiAnalysisError: 'AI 分析失败，请稍后重试',
      aiSummary: '综合结论',
      aiScoreReason: '评分依据',
      aiStrategySummary: '策略总结',
      aiEntryExit: '进出场逻辑',
      aiPriceSensitivity: '价格敏感度',
      aiTakeProfit: '止盈 / 止损',
      aiRiskControl: '风险控制模型',
      aiHedging: '对冲 / 反向',
      aiNewsTrading: '新闻交易',
      aiFrequency: '频率分析',
      aiSectionExecution: '进出场逻辑',
      aiSectionRisk: '风险控制模型',
      aiSectionBehavior: '特殊行为模式',
      aiStrengths: '优势',
      aiRisks: '风险',
      aiInsights: '洞察',
      aiRecommendation: '跟单建议',
      aiScore: '可跟单评分',
      aiRiskLevel: '风险等级',
      aiRiskLow: '低风险',
      aiRiskMedium: '中风险',
      aiRiskHigh: '高风险',
      aiActionFollow: '建议跟单',
      aiActionCautious: '谨慎跟单',
      aiActionAvoid: '不建议跟单',
      aiTradingStyle: '交易风格',
      aiSuspectedRobot: '疑似高频机器人',
      aiSuspectedMarketMaker: '疑似做市商',
    },
  },
  en: {
    nav: {
      home: 'Home',
      menu: 'Menu',
      leaderboard: 'Leaderboard',
      smartMoneyTrades: 'Smart Money Trades',
      positions: 'My Positions',
      myCopyTrading: 'Copy Trading',
      wallets: 'Wallets',
      invite: 'Invite Friends',
    },
    common: {
      retry: 'Retry',
      backHome: 'Back to Home',
      loading: 'Loading...',
      close: 'Close',
      copy: 'Copy',
      copied: 'Copied',
      login: 'Log in',
      logout: 'Log out',
      confirm: 'Confirm',
      cancel: 'Cancel',
      save: 'Save',
      langZh: '中文',
      langEn: 'English',
    },
    membership: {
      free: 'Free',
      lite: 'Lite',
      pro: 'Pro',
      vip: 'VIP',
      currentTier: 'Current tier',
      upgrade: 'Upgrade membership',
      upgradeTitle: 'Upgrade Membership',
      subtitle: 'Unlock copy trading and trader analytics',
      upgradeKicker: 'Unlock premium features',
      upgradeNow: 'Upgrade now',
      viewPlans: 'View plans',
      upgradeRequired: 'Membership required',
      loading: 'Loading membership plans...',
      loadFailed: 'Failed to load membership plans',
      monthly: 'Monthly',
      yearly: 'Yearly',
      discountTag: '-{percent}%',
      month: 'Month',
      year: 'Year',
      currentPlan: 'Current plan',
      selectPlan: 'Select a plan',
      backToPlans: 'Back to plans',
      badgeFree: 'FREE',
      badgeLite: 'LITE',
      badgePro: 'PRO',
      badgeVip: 'VIP',
      timeHourMinute: '{hours}h {minutes}m',
      feature: {
        marketBrowse: 'Market browsing',
        traderDetail: 'Trader details',
        hotMarketData: 'Hot market data',
        leaderboard: 'Leaderboard access',
        autoCopyRisk: 'Auto copy trading & risk controls',
        allFree: 'All Free features',
        allLite: 'All Lite features',
      },
    },
    points: {
      balance: 'Points',
      buy: 'Buy points',
      buyTitle: 'Buy points',
      buySubtitle: 'POINTS',
      packageTitle: 'Points package',
      minTopupHint: 'Minimum top-up is {min} USD',
      minTopupShort: 'Min {min}',
      estimated: 'Estimated {points} points',
      topupSuccess: 'Points credited',
    },
    redemption: {
      haveCode: 'Have a redemption code?',
      placeholder: 'Enter redemption code',
      validate: 'Verify',
      redeem: 'Redeem',
      invalidCode: 'Invalid redemption code',
      validateFailed: 'Verification failed, please try again',
      redeemFailed: 'Redemption failed, please try again',
      success: '🎉 Redeemed! Membership activated',
      preview: 'Redeem {tier} membership for {months} month(s)',
    },
    payment: {
      selectNetwork: 'Select payment network',
      network: 'Network',
      token: 'Token',
      summary: 'Payment summary',
      creating: 'Creating order...',
      amount: 'Amount',
      expiresIn: 'Expires in',
      payAddress: 'Pay address',
      payUri: 'Payment link',
      refreshStatus: 'Refresh status',
      statusLabel: 'Status',
      waitingPayment: 'Complete the transfer to upgrade your membership',
      successTitle: 'Payment successful',
      successDesc: 'Membership upgraded successfully',
      done: 'Done',
      upgradeSuccess: 'Membership upgraded',
      statusRefreshFailed: 'Failed to refresh status',
      optionsLoadFailed: 'Failed to load payment options',
      createFailed: 'Failed to create payment order',
      statusPending: 'Pending',
      statusConfirming: 'Confirming',
      statusUnderpaid: 'Underpaid',
      statusConfirmed: 'Confirmed',
      statusSettling: 'Settling',
      statusSettled: 'Settled',
      statusExpired: 'Expired',
      statusFailed: 'Failed',
      qrWaiting: 'Generating QR...',
      autoRefresh: 'Auto refresh {seconds}s',
    },
    customName: {
      title: 'Custom Name',
      subtitle: 'CUSTOM NAME',
      hint: 'Only visible to you for easier identification.',
      targetLabel: 'Target',
      placeholder: 'Enter a custom name',
      limit: 'Up to {max} characters',
      saving: 'Saving...',
      clear: 'Clear',
      edit: 'Custom name',
      saveSuccess: 'Custom name updated',
      clearSuccess: 'Custom name cleared',
      saveFailed: 'Failed to save. Please try again.',
      clearFailed: 'Failed to clear. Please try again.',
      loginRequired: 'Please log in to set a custom name.',
    },
    toast: {
      comingSoon: '{feature} is coming soon',
      quickTradeOpened: 'Opened Quick Trade (Telegram)',
      quickTradeInvalid: 'This market has no valid identifier',
      favoriteAdded: 'Added to favorites',
      favoriteRemoved: 'Removed from favorites',
      operationFailed: 'Operation failed. Please try again later.',
      inviteVerifiedWelcome: 'Verified! Welcome to PolyOne!',
    },
    actions: {
      aiInsights: 'AI Insights',
      quickTrade: 'Quick Trade',
      favorited: 'Favorited',
      addFavorite: 'Add to Favorites',
      shareMarket: 'Share Market',
    },
    header: {
      navToggle: 'Open/close navigation',
      searchPlaceholder: 'Search markets, traders, or events...',
      searching: 'Searching...',
      viewAddress: 'View address',
      viewThisAddress: 'View this address',
      traders: 'Traders',
      markets: 'Markets',
      noResults: 'No results found',
      feedback: 'Feedback',
      joinTgGroup: 'Join Telegram Group',
      tgGroupTitle: 'Join our community',
      tgGroupDesc: 'Click to join @polyone_ai for updates and discussions',
      switchLang: 'Switch language',
      balanceLoading: 'Loading balance...',
      balance: 'Balance',
      settings: 'Settings',
      setInterests: 'Set interest categories',
      boundEmail: 'Bound email',
      bindEmail: 'Bind email',
      changeEmail: 'Change email',
    },
    emailBind: {
      title: 'Bind Email',
      desc: 'Please bind your email for account security.',
      emailLabel: 'Email Address',
      emailPlaceholder: 'Enter your email',
      captchaLabel: 'Image Verification',
      captchaPlaceholder: 'Enter image code',
      captchaRefresh: 'Refresh code',
      codeLabel: 'Email Code',
      codePlaceholder: 'Enter email code',
      sendCode: 'Send Code',
      cancel: 'Later',
      confirm: 'Confirm Binding',
      binding: 'Binding...',
      emailRequired: 'Please enter email address',
      captchaRequired: 'Please enter image verification code',
      codeRequired: 'Please enter email verification code',
      sendSuccess: 'Verification code sent',
      sendFailed: 'Failed to send verification code',
      bindSuccess: 'Email bound successfully',
      bindFailed: 'Failed to bind email',
      captchaFailed: 'Failed to get verification code',
      securityTip: 'Your email will be used for account security and important notifications',
    },
    auth: {
      loginRequiredTitle: 'Please log in',
      loginRequiredDesc: 'Log in to view your positions',
      authExpired: 'Session expired. Please log in again.',
    },
    tgLogin: {
      missingParams: 'Missing login parameters. Please try again.',
      loadingTitle: 'Logging in...',
      loadingDesc: 'Please wait while we verify your identity',
      successTitle: 'Login successful!',
      successDesc: 'Redirecting to home...',
      errorTitle: 'Login failed',
      errorDesc: 'Returning to home in 3 seconds...',
    },
    positions: {
      loading: 'Loading positions...',
      loadFailed: 'Load failed',
      fetchFailed: 'Failed to fetch positions',
      emptyTitle: 'My Positions',
      emptyHint: 'No positions yet. Check out "Recommend" to find interesting markets.',
      positions: 'POSITIONS',
      roi: 'ROI',
      wallet: 'Wallet',
      all: 'All',
      current: 'Open',
      settled: 'Settled',
      pageKicker: 'POSITIONS',
      pageSubtitle: 'Manage your prediction market portfolio',
      refresh: 'Refresh',
      refreshShort: 'Refresh',
      totalValue: 'Total value',
      totalUnrealizedPnl: 'Total unrealized PnL',
      totalPnlTooltip: 'Total PnL = Settled + Unredeemed + Unrealized',
      openPositions: 'Open positions',
      openPositionsLabel: 'Open positions',
      historicalWinRate: 'Historical win rate',
      walletList: 'Wallets',
      walletCount: 'wallets',
      active: 'Active',
      selectWallet: 'Select Wallet',
      filterByStatus: 'Filter by Status',
      items: 'items',
      positionsDetail: 'Positions',
      walletRow: 'Positions: {positions} | Cash: {cash}',
      emptyWalletTitle: 'No positions in this wallet',
      emptyWalletDesc: 'Discover some interesting markets',
      noOpen: 'No open positions',
      noUnredeemed: 'No unredeemed positions',
      noSettled: 'No settled positions',
      noHistoryTitle: 'No position history',
      noHistoryDesc: 'Your settled positions will appear here',
      settledTotal: 'Total settled',
      winRate: 'Win rate',
      realizedPnl: 'Realized PnL',
      statusUnredeemed: 'Unredeemed',
      statusClosed: 'Closed',
      statusSettled: 'Settled',
      statusActive: 'Open',
      marketUnknown: 'Unknown market',
      currentValue: 'Current value',
      settledValue: 'Settlement',
      pnlFloating: 'Unrealized PnL',
      pnlWin: 'Profit',
      pnlLoss: 'Loss',
      settledResult: 'Settlement',
      realizedProfit: 'Realized profit',
      realizedLoss: 'Realized loss',
      positionSize: 'Size',
      avgPrice: 'Avg price',
      currentPrice: 'Current',
      buyAvgPrice: 'Buy avg',
      marketResult: 'Result',
      settleTime: 'Settled at',
      investedCost: 'Cost',
      yesterdayPnl: 'Yesterday PnL',
      weekPnl: 'Weekly PnL',
      monthPnl: 'Monthly PnL',
      allTimePnl: 'All-time PnL',
      yesterday: 'Yesterday',
      thisWeek: 'This Week',
      thisMonth: 'This Month',
      allTime: 'All Time',
      tradeSource: 'Trade source',
      sellAction: 'Sell',
      sellPreparing: 'Selling...',
      sellGenerating: 'Generating sell link...',
      sellOpened: 'Opening bot for confirmation',
      sellFailed: 'Sell failed',
      sellSubmitting: 'Submitting sell...',
      sellSuccess: 'Sell submitted',
      sellConfirmTitle: 'Confirm sell',
      sellConfirmSubtitle: 'Position sell',
      sellConfirmTip: 'This will sell the full position size at the current orderbook price.',
      sellConfirmAction: 'Confirm sell',
      sellConfirmWallet: 'Wallet',
      sellConfirmSize: 'Sell size',
      outcome: 'Outcome',
      market: 'Market',
      action: 'Action',
      pnl: 'PnL',
      status: 'Status',
    },
    invite: {
      verifying: 'Verifying invite code...',
      invalidTitle: 'Invalid invite code',
      verifyFailed: 'Failed to verify invite code. Please try again later.',
      welcome: 'Welcome to {brand}',
      inviteCode: 'Invite code',
      tagline: 'AI-powered prediction markets\nCopy top traders in real time',
      joinViaTelegram: 'Join via Telegram',
      firstLoginHint: 'Your account will be created on first login',
    },
    share: {
      invalidTarget: 'The share link contains an invalid target URL.',
      invalidLink: 'Invalid share link',
      loadFailed: 'Failed to load share link',
      redirectingHome: 'Redirecting to home...',
      redirecting: 'Redirecting...',
    },
    notFound: {
      title: 'Page not found',
      desc: 'The page you are looking for does not exist or has been moved.',
    },
    leaderboard: {
      title: 'Leaderboard',
      kicker: 'LEADERBOARD',
      subtitle: 'Multiple leaderboards across metrics to find consistent winners fast, with direct address access.',
      lockedTitle: 'Leaderboard is for members only',
      lockedDesc: 'Upgrade to unlock the full leaderboard, AI scores, and copy-trade entry points.',
      lockedHint: 'Already a member? Refresh your membership status to unlock.',
      boards: {
        rov: 'ROV Board',
        pnl: 'PnL Board',
        winRate: 'Win Rate',
        trades: 'Trades Board',
        active: 'Active Board',
      },
      boardDesc: {
        rov: 'Sorted by 30d ROV for recent return quality.',
        pnl: 'Sorted by 30d total profit for recent top earners.',
        winRate: 'Sorted by 30d win rate for recent consistency.',
        trades: 'Sorted by 30d trades for recent activity.',
        active: 'Sorted by latest activity for recency.',
      },
      addressSearchTitle: 'Address lookup',
      addressSearchPlaceholder: 'Enter trader address (0x...)',
      addressSearchAction: 'View address',
      addressSearchHint: 'Paste a full address to open trader details directly.',
      addressInvalid: 'Please enter a valid Ethereum address',
    },
    leaderboardTable: {
      domainFilter: 'Domain filter',
      clearFilter: 'Clear',
      domainSearchPlaceholder: 'Search domains...',
      categoryFilter: 'Category filter',
      categorySports: 'Sports',
      categoryPolitics: 'Politics',
      categoryCrypto: 'Crypto',
      categoryHint: 'NBA only for now. More leagues coming soon.',
      soon: 'Soon',
      leagueSoccer: 'Soccer',
      discoveredTraders: 'Found {count} quality traders',
      shareLeaderboard: 'Share leaderboard',
      refresh: 'Refresh list',
      share: 'Share',
      portfolioCopyTop10: 'Portfolio copy (Top 10)',
      portfolioCopyLoading: 'Creating...',
      portfolioCopyNone: 'No traders available',
      portfolioCopyOpened: 'Opened portfolio bot ({count} traders)',
      portfolioRiskTitle: 'Portfolio risk warning',
      portfolioRiskSubtitle: 'PORTFOLIO RISK',
      portfolioRiskConfirmTitle: 'Suspicious addresses detected',
      portfolioRiskDesc: '{count} addresses in Top 10 are flagged as suspected HFT bots or market makers. You can copy only safe addresses or continue with all.',
      portfolioRiskListTitle: 'Flagged addresses',
      portfolioRiskListCount: '{count}',
      portfolioRiskCancel: 'Cancel copy',
      portfolioRiskFollowSafe: 'Copy safe only',
      portfolioRiskContinue: 'Continue with all',
      portfolioRiskNoSafe: 'No safe addresses to copy',
      shareNeedLogin: 'Please log in to use sharing',
      copyNeedLogin: 'Please log in to use copy trading',
      shareCopied: 'Share link copied to clipboard',
      linkCopied: 'Link copied',
      shareCreateFailed: 'Failed to create share link. Please try again.',
      leaderboardLoadFailed: 'Failed to load leaderboard. Please try again.',
      follow: 'Copy',
      generatingConfig: 'Generating copy config...',
      followCreateFailed: 'Failed to create copy config',
      winRate: 'Win rate (30d)',
      totalProfit: 'Total profit (30d)',
      lastActive: 'Last active',
      justNow: 'Just now',
      secondsAgo: '{n}s ago',
      minutesAgo: '{n}m ago',
      hoursAgo: '{n}h ago',
      daysAgo: '{n}d ago',
      trades: 'Trades (30d)',
      tradesCount: 'Trades (30d)',
      botTag: 'Bot',
      botRiskTitle: 'AI risk warning',
      botRiskSubtitle: 'AI RISK',
      botRiskConfirmTitle: 'Continue copy trading?',
      botRiskDesc: 'This trader address ({name}) is flagged by AI as {type}. Copy trading may carry risk. Continue?',
      botRiskCancel: 'Cancel',
      botRiskConfirm: 'Continue',
      tradingStyle: 'Trading style',
      suspectedRobot: 'Suspected HFT bot',
      suspectedMarketMaker: 'Suspected market maker',
      rank: 'Rank',
      trader: 'Trader',
      domains: 'Domains',
      actions: 'Actions',
      analyzing: 'Analyzing on-chain data...',
      noTraders: 'No traders found',
      sorting: 'Sort',
      asc: 'Asc',
      desc: 'Desc',
      aiScore: 'AI Score',
      aiScoreHint: 'Composite score based on trading history and risk profile',
    },
    customName: {
      title: 'Custom Name',
      subtitle: 'CUSTOM NAME',
      hint: 'Set a recognizable name for this config',
      targetLabel: 'Target',
      placeholder: 'Enter custom name',
      limit: 'Max {max} characters',
      saveSuccess: 'Name saved',
      saveFailed: 'Failed to save',
      clearSuccess: 'Name cleared',
      clearFailed: 'Failed to clear',
      saving: 'Saving...',
      clear: 'Clear',
    },
    leaderboardSidebar: {
      tabLeaderboard: 'Leaderboard',
      tabInsightsSoon: 'Insights (soon)',
      tabSoonToast: 'Coming soon',
      smartMoney: 'Smart Money',
      title: 'Leaderboard',
      lastActive: 'Last active',
      totalProfit: 'Total profit (30d)',
      winRate: 'Win rate (30d)',
      volume: 'Volume (30d)',
      domainLabel: 'Domains',
      uncategorized: 'Uncategorized',
      activeOn: 'Active {date}',
      viewDetail: 'View',
      totalTrades: '{count} trades (30d)',
      generatingConfig: 'Creating copy config...',
      botNotConfigured: 'Bot not configured. Please try again later.',
      jumpToBot: 'Opened bot (Telegram)',
      createFailed: 'Failed to create copy config. Please try again.',
      domainFilter: 'Domain filter',
      clear: 'Clear',
      searchPlaceholder: 'Search trader address or username',
      domainSearchPlaceholder: 'Find domain',
      noMatchedDomains: 'No matching domains',
      noSmartMoney: 'No smart money traders found',
    },
    smartMoneyTrades: {
      title: 'Smart Money Trades',
      monitoring: 'Live monitoring',
      disconnected: 'Disconnected',
      live: 'Live',
      paused: 'Paused',
      close: 'Close',
      noTrades: 'No live trades',
      scanning: 'AI is scanning on-chain data...',
      copyTrade: 'Copy Trade',
      followTrader: 'Follow',
      copyAddress: 'Copy address',
      addressCopied: 'Trader address copied',
      jumpedToCopy: 'Opened Telegram Bot for copy trade',
      generatingConfig: 'Creating copy config...',
      jumpedToFollow: 'Opened Telegram Bot for follow',
      createConfigFailed: 'Failed to create copy config',
      createConfigFailedRetry: 'Failed to create copy config. Please try again.',
      rov: 'ROV',
      winRate: 'Win Rate',
      profit: 'Profit',
      prediction: 'Prediction',
      price: 'Price',
      quantity: 'Qty',
      totalValue: 'Total',
      option: 'Option',
      amount: 'Amount',
      justNow: 'Just now',
      secondsAgo: '{n}s ago',
      minutesAgo: '{n}m ago',
      hoursAgo: '{n}h ago',
      daysAgo: '{n}d ago',
      footerText: 'Showing {count} live trades · Max 50',
      floatingButton: 'Smart Money',
    },
    copyConfigModal: {
      title: 'Configure Copy Trading',
      subtitle: 'COPY CONFIG',
      defaultName: 'Copy {name}',
      portfolioDefaultName: 'Portfolio Copy {count}',
      defaultNameFallback: 'Copy Config',
      portfolioTitle: 'Portfolio Copy',
      portfolioCount: '{count} traders',
      addressesLabel: 'Addresses',
      unknownTrader: 'Unknown trader',
      copyAddress: 'Copy address',
      copyAllAddresses: 'Copy all addresses',
      addressCopied: 'Address copied',
      addressesCopied: 'Addresses copied',
      copyFailed: 'Copy failed',
      winRate: 'Win rate',
      totalProfit: 'Total profit',
      aiScore: 'AI score',
      tradingStyle: 'Trading style',
      nameLabel: 'Copy name',
      namePlaceholder: 'Name this copy config',
      nameRequired: 'Please enter a name',
      nameTooLong: 'Name is too long',
      amountLabel: 'Amount per market (USDC)',
      amountPlaceholder: 'e.g. 10',
      amountInvalid: 'Amount must be at least 1',
      amountHint: 'Amount to copy per market',
      advancedSettings: 'Advanced settings',
      investmentLimitLabel: 'Total investment limit (USDC)',
      investmentLimitPlaceholder: 'Leave blank for unlimited',
      investmentLimitInvalid: 'Enter a valid limit (>=1)',
      investmentLimitTooLow: 'Limit must be >= amount per market',
      investmentLimitHint: 'Optional overall cap',
      copySideLabel: 'Copy side',
      copySideBuySell: 'Buy & sell',
      copySideBuyOnly: 'Buy only',
      copySideHint: 'Choose whether to follow sells',
      stopLossLabel: 'Stop loss',
      stopLossOn: 'Enabled',
      stopLossOff: 'Disabled',
      stopLossPlaceholder: 'Auto if blank',
      stopLossInvalid: 'Stop loss must be >= 1',
      stopLossHint: 'Leave blank for auto calculation',
      marketCooldownLabel: 'Same-market, same-side cooldown',
      marketCooldownOn: 'Enabled',
      marketCooldownOff: 'Disabled',
      marketCooldownPlaceholder: 'Minutes, default 3',
      marketCooldownInvalid: 'Cooldown minutes must be an integer between {min} and {max}',
      marketCooldownTooltip: 'When enabled, repeated buys on the same market and same side are blocked per strategy',
      marketCooldownHint: 'When enabled, repeated buys on the same market and same side are blocked during cooldown',
      minuteUnit: 'min',
      creating: 'Creating...',
      confirm: 'Create copy config',
      createSuccess: 'Copy config created',
      createFailed: 'Failed to create copy config',
    },
    copyTrading: {
      loadFailed: 'Failed to load copy configs',
      membershipRequiredDesc: 'This feature is for members only. Upgrade to manage copy trading and risk settings.',
      refreshed: 'Refreshed',
      invalidLossLimit: 'Enter a valid loss limit (>0), or leave empty for unlimited',
      globalRiskUpdated: 'Global risk updated',
      globalRiskUpdateFailed: 'Failed to update global risk',
      autoCopyResumed: 'Auto copy resumed',
      resumeFailed: 'Failed to resume',
      invalidInvestmentLimit: 'Enter a valid investment limit (>0), or leave empty for unlimited',
      invalidStopLossLimit: 'Enter a valid stop-loss (>=1), or leave empty for auto',
      invalidMarketCooldownMinutes: 'Cooldown minutes must be an integer between {min} and {max}',
      strategyRiskUpdated: 'Strategy risk updated',
      strategyRiskUpdateFailed: 'Failed to update strategy risk',
      autoCopyOn: 'Auto copy enabled',
      autoCopyOff: 'Auto copy disabled',
      operationFailed: 'Operation failed',
      deleteConfirm: 'Delete this copy config?',
      deleteFailed: 'Delete failed',
      deletedOk: 'Config deleted',
      selectConfig: 'Select a copy config',
      selectConfigDesc: 'View details and manage your bot',
      pause: 'Pause',
      enable: 'Enable',
      risk: 'Risk',
      delete: 'Delete',
      createdAt: 'Created',
      lastTriggeredAt: 'Last trigger',
      totalTrades: 'Total trades',
      unmatchedTrades: '{count} trades not matched to positions',
      realizedPnl: 'Realized PnL',
      winRate: 'Win rate',
      winsLosses: '{wins} W / {losses} L',
      amountPerTrade: 'Amount',
      riskSettings: 'Risk settings',
      copySide: 'Copy side',
      copySideBuyOnly: 'Buy only',
      copySideBuySell: 'Buy + Sell',
      investmentLimit: 'Investment limit',
      unlimited: 'Unlimited',
      stopLoss: 'Stop-loss',
      stopLossAuto: 'Auto (default 50%)',
      disabled: 'Disabled',
      stopLossTriggered: 'Stop-loss triggered. Auto copy paused.',
      reason: 'Reason:',
      copyingTraders: 'Copying {count} traders',
      pageKicker: 'COPY TRADING',
      pageTitle: 'Copy Trading',
      refreshTitle: 'Refresh',
      systemOnline: 'Online',
      globalRiskTitle: 'Global risk',
      status: 'Status',
      paused: 'Paused',
      normal: 'Normal',
      lossLimit: 'Loss limit',
      pageXofY: 'Page {page} / {total}',
      settledDesc: 'Settled positions will appear here',
      resume: 'Resume',
      edit: 'Edit',
      statTotalConfigs: 'Total configs',
      statAutoCopy: 'Auto copy',
      statTotalTrades: 'Total trades',
      globalModalDesc:
        'Set an account-level maximum loss limit. When reached, all auto-copy tasks will be paused to protect your capital.\nLeave empty for unlimited.',
      lossLimitLabel: 'Loss limit (USDC)',
      lossLimitPlaceholder: 'e.g. 200',
      saveSettings: 'Save settings',
      strategyModalTitle: 'Strategy risk settings',
      investmentLimitLabelWithUnit: 'Investment limit (USDC)',
      investmentLimitPlaceholder: 'Empty = unlimited, e.g. 500',
      investmentLimitHint: 'Maximum total principal allowed for this config.',
      stopLossTitle: 'Stop-loss',
      stopLossHint: 'Counts settled losses only. Minimum stop-loss is $1.',
      stopLossThresholdLabel: 'Stop-loss threshold (USDC)',
      stopLossThresholdPlaceholder: 'Empty = auto, e.g. 20',
      stopLossAutoHint:
        'If empty, it will auto-calc at the next settlement using 50% and lock it as a fixed threshold (min $1).',
      configLabel: 'Config',
      loading: 'Loading...',
      positionsLoading: 'Loading positions...',
      openPositionsTitle: 'Open positions',
      positionsCount: '{count} positions',
      noMatchedPositions: 'No positions matched',
      noMatchedHint: 'Refresh after trades are executed',
      closedPositionsTitle: 'Settled positions',
      closedPositionsCount: '{count} settled',
      noClosedPositions: 'No settled positions',
      directionTrades: 'Direction: {direction} · {count} trades',
      settlementTime: 'Settled at',
      cost: 'Cost',
      currentValue: 'Value',
      settledValue: 'Settled',
      pnl: 'PnL',
      currentPrice: 'Price',
      loadingConfigs: 'Loading copy configs...',
      noConfigs: 'No configs',
      configList: 'Configs',
      traderUnit: 'traders',
      tradeUnit: 'trades',
      tradersCount: '{count} traders',
      tradesCount: '{count} trades',
      allDomains: 'All domains',
      pauseGlobal: 'Pause',
      pauseGlobalConfirm: 'Pause global copy trading? This will disable all auto-copy configs.',
      pauseGlobalOk: 'Global copy trading paused',
      pauseGlobalFailed: 'Failed to pause',
      resumeGlobalOk: 'Auto copy trading resumed',
      reasonInsufficientBalance: 'Insufficient balance: current {current}, required {required}',
      reasonLossLimit: 'Loss limit reached',
      reasonManual: 'Manually paused',
      pauseReasonInsufficientBalance: 'Insufficient balance',
      pauseReasonInsufficientPoints: 'Insufficient points',
      pauseReasonManual: 'Manually paused',
      autoOn: 'Auto On',
      autoOff: 'Auto Off',
      unnamedConfig: 'Unnamed Config',
      noConfigSelected: 'No config selected',
      selectConfigPrompt: 'Please select a copy config from the list to view details',
      loadingDetail: 'Loading detail...',
      configDetail: 'Config Detail',
      editName: 'Edit Name',
      off: 'Off',
      traders: 'Traders',
      unknownMarket: 'Unknown market',
      openedAt: 'Opened at',
      closedAt: 'Closed at',
      investmentLimitLabel: 'Investment Limit',
      stopLossEnabled: 'Enable Stop Loss',
      stopLossLimitPlaceholder: 'Stop loss threshold',
      marketCooldownEnabled: 'Same-market, same-side cooldown',
      marketCooldownMinutesPlaceholder: 'Cooldown minutes (default 3)',
      marketCooldownDesc: 'When enabled, repeated buys on the same market and same side are blocked per strategy',
      minuteUnit: 'min',
      strategyRiskTitle: 'Strategy Risk',
      openPositions: 'Open Positions',
      closedPositions: 'Settled Positions',
      tradersList: 'Trader List',
      viewTrader: 'View',
      noOpenPositions: 'No open positions',
      noClosedPositions: 'No settled positions',
      tradeHistory: 'Trade History',
      tradeHistoryDesc: 'All copy trading records',
      noTrades: 'No trade records',
      noTradesHint: 'Trade records will appear here after auto copy is enabled',
      actionBuy: 'BUY',
      actionSell: 'SELL',
      tradeAmount: 'Amount',
      tradePrice: 'Price',
      tradeShares: 'Shares',
      tradeTime: 'Time',
      tradeTrader: 'Source Trader',
      loadTradesFailed: 'Failed to load trades',
    },
    wallets: {
      loginRequiredTitle: 'Please log in',
      loginRequiredDesc: 'Log in to view your wallets',
      loading: 'Loading wallets...',
      loadFailed: 'Load failed',
      fetchFailed: 'Failed to load data',
      addressCopied: 'Address copied to clipboard',
      copyFailed: 'Copy failed',
      setTradingWalletOk: 'Set as primary trading wallet',
      setFailed: 'Set failed',
      exportFailed: 'Export failed',
      requestFailed: 'Request failed',
      tradingWalletCannotDelete: 'Primary trading wallet cannot be deleted. Switch it first.',
      deleteWalletConfirm: 'Remove this wallet? This cannot be undone without admin help.',
      walletRemoved: 'Wallet removed',
      removeFailed: 'Remove failed',
      invalidWalletAddress: 'Enter a valid wallet address',
      whitelistAdded: 'Added to whitelist',
      addFailed: 'Add failed',
      whitelistRemoved: 'Removed from whitelist',
      removeWhitelistConfirm: 'Remove {address} from whitelist?',
      walletManagement: 'Wallet Management',
      title: '💼 Your wallets',
      refreshTitle: 'Refresh',
      manageWhitelist: 'Manage whitelist',
      noWallets: 'You have no wallets yet',
      walletLabel: 'Wallet {label}',
      systemCreated: 'System-created',
      userImported: 'User-imported',
      createdAt: 'Created',
      setAsTradingWallet: 'Set as trading wallet',
      setAsPrimary: 'Set as primary',
      deposit: 'Deposit',
      withdraw: 'Withdraw',
      removeWallet: 'Remove wallet',
      totalUsdc: 'Total USDC',
      totalPol: 'Total POL',
      walletCount: 'Wallets',
      tradingWallet: 'Trading Wallet',
      notSet: 'Not set',
      active: 'Active',
      inactive: 'Inactive',
      mainWallet: 'Main',
      walletList: 'Wallet List',
      usdcBalance: 'USDC Balance',
      polBalance: 'POL Balance',
      noWalletsHint: 'System will create your first wallet automatically',
    },
    whitelist: {
      title: 'Withdrawal whitelist',
      subtitle: 'Withdrawal Whitelist',
      intro: 'Funds can only be withdrawn to whitelisted addresses. If empty, withdrawals are disabled.',
      hint: 'Add exchange or cold wallet addresses for safety.',
      placeholder: 'Enter Polygon (0x...) address',
      add: 'Add',
      remove: 'Remove',
      empty: 'No whitelisted addresses. Withdrawals are disabled.',
      list: 'Whitelist',
      addresses: 'addresses',
    },
    deposit: {
      title: 'Deposit',
      warningTitle: 'Important',
      warningLine1: 'Only deposit via Polygon (PoS).',
      warningLine2: 'Deposits from other networks may be permanently lost.',
      copyAddress: 'Address copied',
      saveQr: 'Save QR',
      copiedImage: 'Image copied',
      qrCopied: 'QR image copied',
      imageGenFailed: 'Failed to generate image',
      imageCopyFailed: 'Failed to copy image. Please take a screenshot.',
      imageGenError: 'Image generation error',
      depositAddress: 'Deposit address (Polygon)',
      tradingFunds: 'Trading funds',
      gasFee: 'Gas fee',
    },
    withdraw: {
      title: 'Withdraw',
      fromWallet: 'From',
      token: 'Token',
      amount: 'Amount',
      balance: 'Balance',
      max: 'Max',
      toAddress: 'To address',
      safeHint: 'Safe withdrawals currently support USDC only and require no gas (paid by relayer).',
      eoaHint: 'EOA withdrawals require a small POL balance for gas.',
      cancel: 'Cancel',
      confirm: 'Confirm',
      submitOk: 'Withdrawal submitted. Waiting for confirmation.',
      success: 'Transfer successful',
      failed: 'Transfer failed',
      timeout: 'Confirmation timed out. Check status later.',
      fillAll: 'Please fill in all fields',
      invalidTo: 'Enter a valid recipient address',
      amountGt0: 'Amount must be greater than 0',
    },
    privateKey: {
      title: 'Export private key',
      copied: 'Private key copied to clipboard',
      warningTitle: '⚠️ Security warning',
      warningLine1: 'Your private key controls your funds. Never share it with anyone.',
      warningLine2: 'If leaked, your funds may be lost permanently.',
      yourKey: 'Your private key',
      hide: 'Hide',
      show: 'Show',
      copy: 'Copy',
      copiedShort: 'Copied',
      close: 'Close',
    },
    inviteManage: {
      loginRequiredTitle: 'Please log in',
      loginRequiredDesc: 'Log in to view your invite code and stats',
      loading: 'Loading...',
      noCodeTitle: 'No invite code',
      noCodeDesc: 'Contact admin to get invite permission',
      unavailableTitle: 'Not available yet',
      unavailableDesc: 'Invites are currently unavailable',
      copiedLink: 'Invite link copied',
      copiedMessage: 'Invite message copied',
      messageTemplate:
        '🎁 You are invited to join {brand}!\n\nAI-powered prediction markets with top trader copy trading.\n\nInvite code: {code}\n\nJoin via Telegram (recommended):\n{telegramLink}\n\nOr open the web app:\n{webLink}',
      pageTitle: 'Invite friends',
      pageDesc: 'Share your invite code and invite friends to {brand}.',
      yourCode: 'My invite code',
      codeCopied: 'Invite code copied',
      copy: 'Copy',
      yourCredential: 'Your personal invite credential',
      invitedFriends: 'Invited friends',
      invitedCountDesc: 'Total successful invites',
      shareMethods: 'Share methods',
      telegramInvite: 'Telegram invite link',
      telegramInviteDesc: 'A bot invite link (recommended)',
      webInvite: 'Web invite link',
      webInviteDesc: 'A web signup link (browser-friendly)',
      messageInvite: 'Invite message',
      messageInviteDesc: 'Copy a full invite message for any platform',
      copied: 'Copied',
      copyLink: 'Copy link',
      copyText: 'Copy message',
      historyTitle: 'Invite history',
      recentN: 'Last {count}',
      unknownUser: 'Unknown user',
      noInvites: 'No invite records',
      noInvitesHint: 'Share your invite code to get started!',
      activity: 'Activity',
      keepSharing: 'Keep sharing to earn more rewards',
    },
    inviteCodeModal: {
      needCode: 'Enter a 6-character invite code',
      invalid: 'Invalid invite code',
      verifyFailed: 'Verification failed. Please try again.',
      titleInput: 'Enter invite code',
      titleSuccess: 'Verified',
      subtitleInput: 'PolyOne is in beta. An invite code is required.',
      subtitleSuccess: 'Welcome to PolyOne!',
      redirecting: 'Redirecting...',
      verifying: 'Verifying...',
      verifyButton: 'Verify invite code',
      noCodeHint: 'No invite code? Ask a registered user for one.',
      otherAccount: 'Log in with another account',
      ariaInput: 'Enter 6-character invite code',
    },
    loginModal: {
      kicker: 'AUTH',
      title: 'Log in to {brand}',
      closeAria: 'Close login dialog',
      desc: 'Log in with Telegram — no signup required.',
      button: 'Log in with Telegram',
      hint: "You'll be redirected to Telegram.\nThe bot will send you a login link.",
      terms: 'By logging in, you agree to our Terms and Privacy Policy.\nAn account will be created on first login.',
      telegramTab: 'Telegram',
      emailTab: 'Email',
      switchToEmail: 'Log in with email',
      switchToTelegram: 'Log in with Telegram',
      or: 'or',
      emailTitle: 'Email login',
      emailLabel: 'Email address',
      emailPlaceholder: 'Enter your email',
      emailCaptchaLabel: 'Captcha',
      emailCaptchaPlaceholder: 'Enter captcha',
      emailCaptchaRefresh: 'Refresh captcha',
      emailCodeLabel: 'Email code',
      emailCodePlaceholder: 'Enter email code',
      emailSendCode: 'Send code',
      emailLoginAction: 'Email login',
      emailLogging: 'Logging in...',
      emailRequired: 'Please enter your email',
      emailCaptchaRequired: 'Please enter the captcha',
      emailCodeRequired: 'Please enter the email code',
      emailCodeSent: 'Code sent',
      emailSendFailed: 'Failed to send code',
      emailLoginFailed: 'Email login failed',
      emailCaptchaFailed: 'Failed to load captcha',
    },
    emailBind: {
      title: 'Bind email',
      subtitle: 'EMAIL BINDING',
      desc: 'For account security, please bind your email.',
      emailLabel: 'Email address',
      emailPlaceholder: 'Enter your email',
      captchaLabel: 'Image captcha',
      captchaPlaceholder: 'Enter captcha',
      captchaRefresh: 'Refresh captcha',
      captchaLoading: 'Loading...',
      captchaFailed: 'Failed to load captcha',
      emailRequired: 'Please enter your email',
      captchaRequired: 'Please enter the captcha',
      codeLabel: 'Email code',
      codePlaceholder: 'Enter email code',
      sendCode: 'Send code',
      resendIn: 'Retry in {n}s',
      sendSuccess: 'Verification code sent',
      sendFailed: 'Failed to send code',
      codeRequired: 'Please enter the email code',
      bindSuccess: 'Email bound successfully',
      bindFailed: 'Failed to bind email',
      cancel: 'Later',
      confirm: 'Bind',
      binding: 'Binding...',
      securityTip: 'Your email will be used for account security and important notifications',
    },
    traderDetail: {
      backToPrevious: 'Back',
      anonymousTrader: 'Anonymous Trader',
      traderDescription: "This trader's historical performance and position analysis on PolyOne.",
      share: 'Share',
      copyTrade: 'Copy',
      winRate: 'Win Rate',
      totalPnl: 'Total PnL',
      totalVolume: 'Total Volume',
      last30dBadge: 'Last 30d',
      domainDistribution: 'Domain Distribution',
      performanceAnalysis: 'Performance Analysis',
      riskMetrics: 'Risk Analysis',
      periodDay: 'D',
      periodWeek: 'W',
      periodMonth: 'M',
      totalInvested: 'Invested',
      totalReturn: 'Return',
      volatility: 'Volatility',
      maxDrawdown: 'Max Drawdown',
      sharpeRatio: 'Sharpe Ratio',
      currentPositions: 'Current Positions',
      activityTitle: 'Activity',
      activitySubtitle: 'ACTIVITY',
      activityRecords: '{count} records',
      activityEmpty: 'No activity records',
      activityEmptyDesc: 'No activity records available yet',
      activityLoadMore: 'Load more',
      activityValue: 'Value',
      activityPrice: 'Price',
      activitySize: 'Size',
      activityTx: 'Tx',
      activityTypeTrade: 'Trade',
      activityTypeRedeem: 'Redeem',
      activityTypeMerge: 'Merge',
      activityTypeSplit: 'Split',
      activityTypeReward: 'Reward',
      activityTypeConversion: 'Conversion',
      activitySideBuy: 'Buy',
      activitySideSell: 'Sell',
      positionsOngoing: '{count} open',
      deadline: 'Ends',
      invested: 'Invested',
      currentValue: 'Value',
      noPositions: 'No open positions',
      tradeHistory: 'Trade History',
      showingRecent: 'Showing {count} recent',
      market: 'Market',
      direction: 'Direction',
      pnl: 'PnL',
      noHistory: 'No trades yet',
      loadFailed: 'Load failed',
      loadDetailFailed: 'Failed to load trader details. Please try again.',
      membershipRequiredDesc: 'This page is for members only. Upgrade to view full trader data.',
      pointsInsufficientTitle: 'Insufficient points',
      pointsInsufficientDesc: 'Unlocking this trader detail requires points.',
      pointsInsufficientHint: 'Upgrade membership or top up points to continue.',
      pointsBalanceLabel: 'Current points',
      noTrendData: 'No trend data',
      noDistribution: 'No distribution',
      cumulativePnl: 'Cumulative PnL',
      shareRatio: 'Share',
      shareNeedLogin: 'Please log in to share',
      shareCopied: 'Share link copied',
      shareUnavailable: 'Sharing is temporarily unavailable',
      copyNeedLogin: 'Please log in to copy trade',
      botNotConfigured: 'Bot not configured. Please try again later.',
      generatingConfig: 'Creating copy config...',
      jumpedToBot: 'Opened copy trading bot',
      createConfigFailed: 'Failed to create copy config',
      createConfigFailedRetry: 'Failed to create copy config. Please try again.',
      botRiskTitle: 'AI risk warning',
      botRiskSubtitle: 'AI RISK',
      botRiskDesc: 'This trader address ({name}) is flagged by AI as {type}. Copy trading may carry risk. Continue?',
      botRiskCancel: 'Cancel',
      botRiskConfirm: 'Continue',
      aiAnalysisTitle: 'AI Analysis',
      aiAnalysisSubtitle: 'TRADER INSIGHT',
      aiAnalysisLoading: 'AI is analyzing this trader...',
      aiAnalysisError: 'AI analysis failed. Please try again.',
      aiSummary: 'Summary',
      aiScoreReason: 'Score rationale',
      aiStrategySummary: 'Strategy summary',
      aiEntryExit: 'Entry & Exit Logic',
      aiPriceSensitivity: 'Price Sensitivity',
      aiTakeProfit: 'Take Profit / Stop Loss',
      aiRiskControl: 'Risk Control',
      aiHedging: 'Hedging / Reversal',
      aiNewsTrading: 'News Trading',
      aiFrequency: 'Trading Frequency',
      aiSectionExecution: 'Entry & Exit Logic',
      aiSectionRisk: 'Risk Control Model',
      aiSectionBehavior: 'Behavior Patterns',
      aiStrengths: 'Strengths',
      aiRisks: 'Risks',
      aiInsights: 'Insights',
      aiRecommendation: 'Copy-trade advice',
      aiScore: 'Copy-trading score',
      aiRiskLevel: 'Risk level',
      aiRiskLow: 'Low',
      aiRiskMedium: 'Medium',
      aiRiskHigh: 'High',
      aiActionFollow: 'Follow',
      aiActionCautious: 'Cautious',
      aiActionAvoid: 'Avoid',
      aiTradingStyle: 'Trading style',
      aiSuspectedRobot: 'Suspected HFT bot',
      aiSuspectedMarketMaker: 'Suspected market maker',
    },
  },
};
